import styled from "styled-components";
import { CalendarIcon } from "./shared/assets/CalendarIcon";

export const Container = styled.div<{ hasMaxWidth?: boolean }>`
  max-width: ${props => props.hasMaxWidth ? "1500px" : "none"};
  padding: 20px;
`;

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 29px;
  width: 158px;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  color: #FFF;
  border: none;
  border-radius: 3px;
`;

export const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;

export const ChangeDateButton = styled(StyledButton)`
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.orangeBackground};
  border-radius: 15px;
`;

export const BulkUpdateButton = styled(StyledButton)`
  background-color: ${({ theme }) => theme.darkBlueBackground};
  border-radius: 12px;
`;

export const CalendarIconContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 29px;
  height: 29px;
  margin-left: 20px;
  cursor: pointer;
  flex: 0;
  
  svg, path {
    fill: #808080;
  }
`;

export const Loader = styled.big`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 30px;
  color: #808080;
`;

export const StyledCalendarIcon = styled(CalendarIcon)`
  cursor: pointer;
`;
